import { useLazyQuery } from '@apollo/client/react'
import type { Address } from '@ztechapps/common.contract'
import { extractOrderAddressesQuery } from '../graphql'

export type UseExtractOrderAddressesResult = {
  extractAddresses: (orderId: string) => Promise<Address[]>
  loading: boolean
  error: Error | undefined
  addresses: Address[] | undefined
}

export const useExtractOrderAddresses = (): UseExtractOrderAddressesResult => {
  const [extractAddressesQuery, { loading, error, data }] = useLazyQuery<{
    extractOrderAddresses: Address[]
  }>(extractOrderAddressesQuery)

  const extractAddresses = async (orderId: string): Promise<Address[]> => {
    const result = await extractAddressesQuery({
      variables: {
        input: {
          orderId,
        },
      },
    })

    return result.data?.extractOrderAddresses ?? []
  }

  return {
    extractAddresses,
    loading,
    error: error as Error | undefined,
    addresses: data?.extractOrderAddresses,
  }
}
